import { ShieldCheck, FlaskConical, Microscope, FileCheck2, Lock, BadgeCheck } from "lucide-react";
import { motion } from "framer-motion";

const BADGES = [
  { icon: BadgeCheck, label: "99%+ Purity Standard" },
  { icon: FlaskConical, label: "Research Use Only" },
  { icon: Microscope, label: "Third-Party Tested" },
  { icon: FileCheck2, label: "Batch Tested" },
  { icon: Lock, label: "Secure Checkout" },
];

export default function TrustBadgeBar({ className = "" }) {
  return (
    <div className={`relative border-y border-blue-100 bg-gradient-to-b from-blue-50/70 to-white ${className}`} data-testid="trust-badge-bar">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-5 flex flex-wrap items-center justify-center gap-3">
        {BADGES.map((b, idx) => (
          <motion.div
            key={b.label}
            initial={{ opacity: 0, y: 8 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.35, delay: idx * 0.05 }}
            className="flex items-center gap-2 bg-white border border-blue-100 rounded-full px-3.5 py-1.5 shadow-sm hover:shadow-blue-glow-sm hover:border-blue-300 hover:-translate-y-0.5 transition-all duration-300"
            data-testid={`trust-badge-${b.label.toLowerCase().replace(/\s+/g, "-")}`}
          >
            <b.icon className="h-3.5 w-3.5 text-brandblue-600" strokeWidth={1.5} />
            <span className="text-xs font-semibold uppercase tracking-wider text-slate-600">{b.label}</span>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
